import { render, staticRenderFns } from "./ProjectSetUp.vue?vue&type=template&id=3f7ae4c8"
import script from "./ProjectSetUp.vue?vue&type=script&lang=js"
export * from "./ProjectSetUp.vue?vue&type=script&lang=js"
import style0 from "./ProjectSetUp.vue?vue&type=style&index=0&id=3f7ae4c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports